//// Core Scripts
import "bootstrap";

// Custom Styles
import "../styles/app.scss";

// Polyfills
import "core-js/stable";

// Initialization
const browserDate = document.getElementById("login-form-slim-browser-date") as HTMLInputElement;
if (browserDate) {
  // Used to set the user's time zone when they login.
  browserDate.value = (new Date()).toString();
}
